import axios, {
  InternalAxiosRequestConfig,
  AxiosError,
  AxiosResponse,
} from "axios";
import { get_cookie } from "../config/cookie";
import { logout_user } from "../services/api/auth";

// config
const base_url = process.env.REACT_APP_BASE_URL;

const headers = {};

const axiosInstance = axios.create({
  baseURL: base_url,
  headers,
});

console.log(base_url);

axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // old setup
    // const serial: string | null = localStorage.getItem("@serial");
    // if (serial) {
    //   config.headers.Authorization = `bearer ${serial}`;
    // Try to get the decrypted token from the cookie first
    // const token = get_cookie("@serial") || localStorage.getItem("@token"); old
    const token =
      get_cookie("@serial") ||
      localStorage.getItem("@token") ||
      localStorage.getItem("@serial");

    if (token) {
      config.headers.Authorization = `bearer ${token}`;
    }
    config.headers.Accept = "application/json";
    if (
      config.data &&
      typeof config.data === "object" &&
      !(config.data instanceof FormData)
    ) {
      config.headers["Content-Type"] = "application/json";
    } else {
      delete config.headers["Content-Type"];
    }
    return config;
  },
  (error: Promise<AxiosError>) => {
    return Promise.reject(error);
  },
);

// clear cookies and localStorage session token
axiosInstance.interceptors.response.use(
  (response: any): Promise<AxiosResponse> => {
    return response;
  },
  (error: AxiosError): Promise<AxiosError> => {
    if (
      error?.response?.status === 403 &&
      window.location.pathname !== "/login"
    ) {
      logout_user();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
